import request from "@/utils/request";

export function fetchGetPaymentList(userId) {
  return request({
    url: `/payment/api/v1/list/${userId}`,
    method: "get"
  });
}
